import { useQueryParams } from '@/hooks/useQueryParams';
import { useTrackPageView } from '@/hooks/useTrackPageView';
import { useScheduleContext } from '@/pages/Schedule/contexts';
import { getViewType } from '../utils/view';

export const useTrackSchedulePageView = () => {
  const { queryParams } = useQueryParams();
  const { schedule } = useScheduleContext();

  useTrackPageView('schedule', {
    role: schedule?.role.toLowerCase(),
    viewType: getViewType(schedule, queryParams),
  });
};
